module.exports = __webpack_public_path__ + "img/employee-information.0247025d.jpg";